import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-left-old',
  templateUrl: './nav-left-old.component.html',
  styleUrls: ['./nav-left-old.component.css']
})
export class NavLeftOldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/nav-left-old/nav-left-old.component.ts